module.exports = require("vue-virtual-scroller");